export default __webpack_public_path__ + "img/selected_blank.935052c4.svg";